import { render, staticRenderFns } from "./visitor.vue?vue&type=template&id=20b37889&scoped=true"
import script from "./visitor.vue?vue&type=script&lang=js"
export * from "./visitor.vue?vue&type=script&lang=js"
import style0 from "./visitor.vue?vue&type=style&index=0&id=20b37889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b37889",
  null
  
)

export default component.exports